import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import ReactSelectBaseField from "./ReactSelectBaseField";

const SelectMultipleField = ({ descriptor, formHandler }: FormFieldProps) => {
  // render
  return (
    <ReactSelectBaseField 
      descriptor={descriptor}
      formHandler={formHandler}
      isMultiple
    />
  );
};

export default SelectMultipleField;
